/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';

export default declareLinkedEntity({
    entity: "entitySelectionRules",
    graphQL: "EntitySelectionRule",
    storageType: 'central',
    name: "Data Source Entity Selection Rule",
    parentRelation: "entitySelectionRules",
    defaultTitle: (data) => {
        return data['name'];
    },
    isPublic: true,
    fields: (types) => { return {
        id: {
            name: "Entity Selection Rule ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: true,
            isPublic: true,
        },
        entityDef: {
            name: "Connected Entity Definition",
            type: "relation",
            to: () => types['entityDefs'],
            isPublic: true,
        },
        sourceDef: {
            name: "Connected Source Definition",
            type: "relation",
            to: () => types['sourceDefs'],
            isPublic: true,
            relativeTo: ['channelDef'],
        },
        organisation: {
            name: "Connected Organisation",
            type: "relation",
            to: () => types['organisations'],
        },
        channel: {
            name: "Connected Application",
            type: "relation",
            to: () => types['channels'],
        },
        channelDef: {
            name: "Connected Application Definition",
            type: "relation",
            to: () => types['channelDefs'],
            isPublic: true,
        },
        channelDefKey: {
            name: "Connected Application Definition Key",
            type: "string",
            isPublic: true,
        },
        dataSource: {
            name: "Data Source",
            type: "relation",
            to: () => types['dataSources'],
            parent: true, /* we are using multiple (variable) parents */
            relativeTo: ['scenarioScreenDef', 'scenarioDef'],
            compositeKey: true,
            hiddenCreate: true,
        },
        scenarioScreenDef: {
            name: "Screen Definition",
            type: "relation",
            to: () => types['scenarioScreenDefs'],
            compositeKey: true,
            hiddenCreate: true,
            relativeTo: ['scenarioDef'],
            isPublic: true,
        },
        scenarioDef: {
            name: "Scenario Definition",
            type: "relation",
            to: () => types['scenarioDefs'],
            hiddenCreate: true,
            compositeKey: true,
            isPublic: true,
        },
        screenDataSourceToAdd: {
            name: "Data Source",
            type: "relation",
            to: () => types['screenDataSourceToAdd'],
            parent: true, /* we are using multiple (variable) parents */
            compositeKey: true,
            hiddenCreate: true,
        },
    }; },
    relations: (types) => { return {
    }; }
});
